const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;
const MONTH_MS = 30 * DAY_MS;
const YEAR_MS = 365 * DAY_MS;

function parseDate(value?: string | number | Date) {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
}

function pad(value: number) {
  return String(value).padStart(2, "0");
}

export function formatFullDateTime(value?: string | number | Date) {
  const date = parseDate(value);

  if (!date) {
    return "";
  }

  return [
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`,
  ].join(" ");
}

export function formatRelativeTime(value?: string | number | Date) {
  const date = parseDate(value);

  if (!date) {
    return "";
  }

  const diff = Date.now() - date.getTime();

  if (diff < MINUTE_MS) {
    return "刚刚";
  }

  if (diff < HOUR_MS) {
    return `${Math.floor(diff / MINUTE_MS)}分钟前`;
  }

  if (diff < DAY_MS) {
    return `${Math.floor(diff / HOUR_MS)}小时前`;
  }

  if (diff < WEEK_MS) {
    return `${Math.floor(diff / DAY_MS)}天前`;
  }

  if (diff < MONTH_MS) {
    return `${Math.floor(diff / WEEK_MS)}周前`;
  }

  if (diff < YEAR_MS) {
    return `${Math.floor(diff / MONTH_MS)}月前`;
  }

  return `${Math.floor(diff / YEAR_MS)}年前`;
}
